import ApiInstance from "@/services/api/api.utils";
import { CertificateMethods } from "@/services/constants/global";
import {
  parsedApplicantResumeModel,
  parsedAppliedJobModel,
} from "@/services/models/applicant";
import { parseDataWithoutId } from "@/services/models/common";
import { parseUserInformation } from "@/services/models/user";
import { formatDate } from "@/services/utils/formatter";
import { get } from "lodash";

/**
 * Personal information
 */

export const postPersonalInfo = async (personalInfo) => {
  const res = await ApiInstance.post("/personals", personalInfo, {
    "Content-Type": "multipart/form-data",
  });
  return parseUserInformation(res);
};

export const recoverUsername = async ({
  type = "",
  fullName = "",
  phone = "",
  email = "",
}) => {
  const payload = { type, fullName };
  if (payload.type === CertificateMethods.PHONE) {
    payload.phone = phone;
  }
  if (payload.type === CertificateMethods.EMAIL) {
    payload.email = email;
  }
  const res = await ApiInstance.post("personals/recover-username", payload);
  return res;
};

export const resetPassword = async ({
  type = "",
  phone = "",
  email = "",
  fullName = "",
  username = "",
}) => {
  const payload = { type, username, fullName };
  if (payload.type === CertificateMethods.PHONE) {
    payload.phone = phone;
  }
  if (payload.type === CertificateMethods.EMAIL) {
    payload.email = email;
  }
  const res = await ApiInstance.post("personals/reset-password", payload);
  return res;
};

/**
 * Resume
 */

export const getResumes = async () => {
  const res = await ApiInstance.get("/resumes");
  return res ? parsedApplicantResumeModel(res) : null;
};

export const postCreateResume = async (resume) => {
  const res = await ApiInstance.post("/resumes", resume, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return res;
};

export const deleteResume = async (id) => {
  const res = await ApiInstance.delete(`/resumes/${id}`);
  return res;
};

export const getResumeDetails = async (id) => {
  const res = await ApiInstance.get(`/resumes/${id}`);
  return parseDataWithoutId(res);
};

export const postUpdateResume = async (resume) => {
  const res = await ApiInstance.post(`/resumes/updateResume`, resume, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return res;
};

export const patchResumeStatus = async ({ id, payload }) => {
  const res = await ApiInstance.patch(`/resumes/is-receive-interview/${id}`, {
    ...payload,
  });
  return res;
};

export const postQuickCreateResume = async (payload) => {
  const res = await ApiInstance.post("/resumes/quick", payload);
  return res;
};

/**
 * Introduction video
 */

export const getPersonalIntroductionVideos = async (params) => {
  const res = await ApiInstance.get("/user-introduction-video", { params });
  return {
    ...res,
    docs: res.docs.map((item) => ({
      ...item,
      createdAt: formatDate(get(item, "createdAt")),
    })),
  };
};

export const getPersonalIntroductionVideoDetail = async (id) => {
  const res = await ApiInstance.get(`/user-introduction-video/${id}`);
  return parseDataWithoutId(res);
};

export const deleteIntroductionVideo = async (id) => {
  const res = await ApiInstance.delete(`/user-introduction-video/${id}`);
  return res;
};

export const postCreateIntroductionVideo = async (payload) => {
  const res = await ApiInstance.post("/user-introduction-video", payload);
  return res;
};

export const putUpdateIntroductionVideo = async (id, payload) => {
  const res = await ApiInstance.put(`/user-introduction-video/${id}`, payload);
  return res;
};

export const postUpdateIntroductionVideo = async (
  userIntroductionVideoId,
  payload
) => {
  const res = await ApiInstance.post(
    `/resumes/update-user-introduction-video/${userIntroductionVideoId}`,
    payload
  );
  return res;
};

/**
 * Job apply
 */

export const postRequestApplyJob = async (payload) => {
  const res = await ApiInstance.post("/applicants", payload);
  return res;
};

export const getAppliedJobs = async (params) => {
  const res = await ApiInstance.get("/applicants/personals", { params });
  return {
    ...res,
    docs: res.docs.map((item) => parsedAppliedJobModel(item)),
  };
};
